// @flow
import * as React from 'react';

import { selectCartCurrency } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base, Badge, Text } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { useFeatureFlags } from 'src/hooks/useFeatureFlag';

import { ListRow } from '../../../../ListRow';

import DetailRow from './DetailRow';
import type { Props as DetailRowProps } from './DetailRow';

type Props = {
  label: string,
  detail?: DetailRowProps['detail'],
  price: DetailRowProps['price'],
};

export function DiscountRow({
  label,
  detail,
  price,
}: Props): React.MixedElement {
  const { FF_CART_OVERVIEW_NDS } = useFeatureFlags();
  const { __, formatPrice } = useTranslator();
  const currency = useAppSelector(selectCartCurrency);

  const badge = <Badge intent="promotional">{__('Promo')}</Badge>;
  const negativePrice =
    typeof price === 'number' && price > 0 ? -1 * price : price;

  if (FF_CART_OVERVIEW_NDS) {
    return (
      <Base paddingY="xsmall">
        <ListRow
          intent="promotional"
          badge={badge}
          price={formatPrice(negativePrice || 0, currency)}
        >
          {label}
        </ListRow>
      </Base>
    );
  }

  const labelRow = (
    <Base flex gap="xxsmall" flexAlignItemsCenter>
      {badge}
      <Text>{label}</Text>
    </Base>
  );

  return <DetailRow label={labelRow} detail={detail} price={negativePrice} />;
}
